import React from "react";
import gql from "graphql-tag";
import { oc } from "ts-optchain";
import get from "lodash/get";
import { useQuery } from "react-apollo";
import { LinkType } from "@types";
import { constants, analytics } from "@services";
import SearchModalResults from "./SearchModalResults";

// == Types ================================================================

interface IProps {
  selectedItem: $FixMe;
  highlightedIndex: $FixMe;
  getItemProps: $FixMe;
  inputValue: string | null;
  linkTypeFilter: LinkType | null;
}

// == Constants ============================================================

const BRAND_SEARCH_QUERY = gql`
  query SearchBarResultsQuery(
    $query: String!
    $first: Int!
    $after: String
    $coordinates: CoordinatesInput
  ) {
    BrandSearch(query: $query, first: $first, after: $after, coordinates: $coordinates)
      @connection(key: "BrandSearch", filter: ["query", "coordinates"]) {
      edges {
        cursor
        node {
          id

          ...SearchModalResultsFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${SearchModalResults.fragments.fields}
`;

// == Component ============================================================

const SearchBarResultsQuery = ({
  selectedItem,
  highlightedIndex,
  getItemProps,
  inputValue,
  linkTypeFilter,
}: IProps) => {
  const { loading, data } = useQuery(BRAND_SEARCH_QUERY, {
    variables: { query: inputValue, first: 100 },
    onCompleted: () => {
      if (inputValue)
        analytics.track.search(
          { analyticsLocation: "store", query: inputValue },
          { search_query: inputValue }
        );
    },
  });

  let brands = oc(data).BrandSearch.edges([]);
  if (linkTypeFilter) {
    // to be replaced with updating the query instead
    // once we update the api to allow filtering by link type
    const filter = `node.${constants.SEARCH_FILTERS_LINK_TYPES[linkTypeFilter]}.id`;
    brands = brands.filter((brand) => {
      return get(brand, filter);
    });
  }
  return <SearchModalResults {...{ inputValue, loading, brands }} />;
};

export default SearchBarResultsQuery;

// == Styles ===============================================================
